import './TourGuide.css';
export default {
    "root": "TourGuide_root__10fch",
    "title": "TourGuide_title__10fch",
    "titleHasCloseButton": "TourGuide_titleHasCloseButton__10fch",
    "content": "TourGuide_content__10fch",
    "contentHasCloseButton": "TourGuide_contentHasCloseButton__10fch",
    "bottomRow": "TourGuide_bottomRow__10fch",
    "stepCount": "TourGuide_stepCount__10fch",
    "stepCountDesktop": "TourGuide_stepCountDesktop__10fch",
    "stepCountMobile": "TourGuide_stepCountMobile__10fch",
    "buttonGroup": "TourGuide_buttonGroup__10fch",
    "leftButton": "TourGuide_leftButton__10fch",
    "rightButtonStandalone": "TourGuide_rightButtonStandalone__10fch",
    "closeButton": "TourGuide_closeButton__10fch"
};
